import { render, staticRenderFns } from "./facebook-like.vue?vue&type=template&id=97f7e292&"
import script from "./facebook-like.vue?vue&type=script&lang=js&"
export * from "./facebook-like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports